module.exports = __webpack_public_path__ + "static/media/pin_red_highlighted.4ad9b4e8.png";